import { convertRowsToData } from '../utils/dataUtils'

export default function HeatMapDataController(rows, config) {
  const propperHeaders = ['id', 'x', 'y', 'color', 'label']
  const headers = rows[0]

  if (headers.length < propperHeaders.length) rows = rows.map((r, i) => [i, ...r])

  const data = convertRowsToData([propperHeaders, ...rows.slice(1)], 3)

  return data
    .map(point => {
      return {
        id: point.id+'-'+point.value.find(d => d.id === 'y').value,
        x: point.value.find(d => d.id === 'x').value,
        y: point.value.find(d => d.id === 'y').value,
        color: point.value.find(d => d.id === 'color').value,
        label: point.label,
      }
    })
    .sort((a, b) => (a.x > b.x ? 1 : a.x !== b.x ? -1 : 0))
    .sort((a, b) => {
      if (config.AxisHelper.y.columnsOrder) {
        return config.AxisHelper.y.columnsOrder[b.y] - config.AxisHelper.y.columnsOrder[a.y]
      }
      if (!isFinite(a.y)) {
        return a.x === b.x ? (a.y > b.y ? -1 : 1) : 0
      } else {
        return a.x === b.x ? a.y - b.y : 0
      }
    })
}
